export default "assets/images/icons/arrow-ef35ee1c.svg";